import api from './api';

export const authService = {
  // Login with email and password
  async login(email, password) {
    const response = await api.post('/auth/login', {
      email,
      password
    });
    
    if (response.data.access_token) {
      localStorage.setItem('authToken', response.data.access_token);
      localStorage.setItem('adminAuth', JSON.stringify({
        isAuthenticated: true,
        user: response.data.user
      }));
    }
    
    return response.data;
  },

  // Login with Google OAuth
  async googleLogin(googleToken) {
    const response = await api.post('/auth/google-login', {
      google_token: googleToken
    });
    
    if (response.data.access_token) {
      localStorage.setItem('authToken', response.data.access_token);
      localStorage.setItem('adminAuth', JSON.stringify({
        isAuthenticated: true,
        user: response.data.user
      }));
    }
    
    return response.data;
  },

  // Get current user info
  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Logout
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('adminAuth');
  },

  // Check if user is authenticated
  isAuthenticated() {
    const token = localStorage.getItem('authToken');
    return !!token;
  },

  // Get stored user data
  getStoredUser() {
    const adminAuth = localStorage.getItem('adminAuth');
    if (adminAuth) {
      const authData = JSON.parse(adminAuth);
      return authData.user;
    }
    return null;
  }
};